import * as React from "react";
import { MemberApplicationState } from "./entity";
import { LoadingSpinner, LoadingError } from "components/controls/widget";
import { useApplication, MemberValidationPhase } from "./store";
import { useMemberValidation } from "../member-validation/store";
import { useCountries } from "../countries/store";
import { useUIContext } from "../context/store";
import { ApplicationForm } from "./form/view";
import { ApplicationPage } from "./page/view";

interface Props {
    applicationId?: number;
    hashCode?: string;
    clubId?: number;
}

const View = ({ applicationId, hashCode, clubId }: Props) => {

    const [state, { loadApplication, setMemberValidationPhase, setClubID, resetDefaults }] = useApplication();

    const [countries, { loadCountries }] = useCountries();
    const [uiContext, uiContextActions] = useUIContext();

    const [memberValidationState, {
        getValidationState,
        invalidateValidationCache,
        showPhoneVerificationCodeDialog
    }
    ] = useMemberValidation();

    React.useEffect(() => {

        if (!uiContext.initialized) {
            uiContextActions.initialize();
        }

        loadCountries();
        resetDefaults();
        setClubID(clubId);

        if (applicationId) {
            loadApplication(applicationId, hashCode, clubId)
        }


    }, []);



    React.useEffect(() => {
        switch (state.memberValidationPhase) {

            case MemberValidationPhase.EmailValidationRequestEnd:
            case MemberValidationPhase.PhoneValidationRequestEnd:
                setMemberValidationPhase(MemberValidationPhase.None);
                invalidateValidationCache();
                break;

            case MemberValidationPhase.PhoneValidationRequestSucceeded:
                setMemberValidationPhase(MemberValidationPhase.AddPhoneValidationCode);
                break;

            case MemberValidationPhase.GetValidationState:
                invalidateValidationCache();
                break;

            case MemberValidationPhase.AddPhoneValidationCode:
                showPhoneVerificationCodeDialog(true);
                setMemberValidationPhase(MemberValidationPhase.PhoneValidationRequestEnd);
                break;
        }
    }, [state.memberValidationPhase]);

    React.useEffect(() => {
        if (memberValidationState.dataValid) {
            switch (state.memberValidationPhase) {
                case MemberValidationPhase.PhoneValidationRequestSucceeded:
                    setMemberValidationPhase(MemberValidationPhase.AddPhoneValidationCode);
                    break;
                default:
                    setMemberValidationPhase();
                    break;
            }
        } else {
            getValidationState(state.entity.id);
        }
    }, [memberValidationState.lastChangeTime]);

    React.useEffect(() => {
        uiContextActions.loadKnownEmail(state.entity.member.email);
    }, [state.entity.member.email]);


    const loading = state.loading || countries.loading;
    const showError = state.loadFailure || countries.loadFailure;
    const showContent = !loading && !showError;
    const showPage = showContent && state.entity.state !== MemberApplicationState.BeingEdited;
    const showForm = showContent && state.entity.state === MemberApplicationState.BeingEdited;
    const editedByClub = clubId != null;

    return <div>
        {loading && <LoadingSpinner />}
        {showError && <LoadingError />}
        {showPage && <ApplicationPage />}
        {showForm && <ApplicationForm editedByClub={editedByClub} />}
    </div>;
}

export {
    View as Application
}
